export default __webpack_public_path__ + "static/media/Stage1_rule.5a9c99cb.png";